export default __webpack_public_path__ + "static/media/bh5.1a07c42a.webp";